import {
    CREATE_APLICACIONLABORAL,
    ERROR_CREATE_APLICACIONLABORAL,
    REQUEST_CREATE_APLICACIONLABORAL,
    RESET_CREATE_APLICACIONLABORAL,
    SUCCESS_CREATE_APLICACIONLABORAL,
} from '../actions/AplicacionLaboralActions';
import {combineReducers} from 'redux';

//lodash
import merge from "lodash/merge";

function create(state = {
    isCreating: false,
    nuevo: {},
    error: ""
}, action) {
    switch (action.type) {
        case CREATE_APLICACIONLABORAL:
            return merge({}, state, {
                isCreating: false,
                nuevo: action.aplicacionLaboral,
                error: null,
            });
        case REQUEST_CREATE_APLICACIONLABORAL:
            return Object.assign({}, state, {
                isCreating: true,
                error: null,
            });
        case SUCCESS_CREATE_APLICACIONLABORAL:
            return Object.assign({}, state, {
                isCreating: false,
                error: null,
            });
        case ERROR_CREATE_APLICACIONLABORAL:
            return Object.assign({}, state, {
                isCreating: false,
                error: action.error
            });
        case RESET_CREATE_APLICACIONLABORAL:
            return Object.assign({}, state, {
                isCreating: false,
                error: null,
                nuevo: {}
            });
        default:
            return state
    }
}


const aplicacionesLaborales = combineReducers({
    create: create,
});

export default aplicacionesLaborales;


// WEBPACK FOOTER //
// ./src/reducers/aplicacionesLaborales.js